import React from 'react';
import ItemRequestContent from './content';
import { ItemRequestProvider } from 'contexts/item-request.context';

const ItemRequestLayout = () => {
  return (
    <ItemRequestProvider>
      <ItemRequestContent />
    </ItemRequestProvider>
  );
};

export default ItemRequestLayout;
